"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageListener = void 0;
var AppSettings_1 = __importDefault(require("../AppSettings/AppSettings"));
var UrlParser_1 = __importDefault(require("../Utils/UrlParser"));
var MessageObservable_1 = __importDefault(require("./MessageObservable"));
var MessageListener = /** @class */ (function () {
    /**
     *
     * @param widgets
     */
    function MessageListener(iframeWidgets) {
        this._iframeWidgets = iframeWidgets;
        this.start();
    }
    /**
     * Inicia la escucha de mensajes
     */
    MessageListener.prototype.start = function () {
        window.addEventListener("message", this.processReceivedMessage.bind(this), false);
    };
    /**
     * Detinene la escucha de mensajes
     */
    MessageListener.prototype.stop = function () {
        window.removeEventListener("message", this.processReceivedMessage.bind(this), false);
    };
    /**
     * Add widget to listener
     * @param iframeWidget
     */
    MessageListener.prototype.addWidget = function (iframeWidget) {
        this._iframeWidgets.push(iframeWidget);
    };
    /**
     * Remove widget from listener
     * @param iframeWidget
     */
    MessageListener.prototype.removeWidget = function (iframeWidget) {
        this._iframeWidgets = this._iframeWidgets.filter(function (widget) { return widget.getConfig().id != iframeWidget.getConfig().id; });
    };
    /**
     * Si el dominio que lo manda es permtido, permite manejar el mensaje
     * @param event
     */
    MessageListener.prototype.processReceivedMessage = function (event) {
        var notificationEvent = event.data;
        if (this.isFromAllowedDomain(event)) {
            this.handleMessage(notificationEvent);
        }
    };
    /**
     * Si hay un widget receptor, se envía al manejador de mensajes
     * @param notificationEvent
     */
    MessageListener.prototype.handleMessage = function (notificationEvent) {
        var senderWidget = this.getWidgetMessage(notificationEvent);
        if (senderWidget) {
            MessageObservable_1.default.handle(senderWidget, notificationEvent);
        }
    };
    /**
     * Mira si el mensaje está generado desde a alguno de los widgets contenidos por esta instancia
     * @param notificationEvent
     */
    MessageListener.prototype.getWidgetMessage = function (notificationEvent) {
        return this._iframeWidgets.find(function (w) { return w.getConfig().id == notificationEvent.targetId; });
    };
    /**
     * Mira que el mensaje venga de un dominio de los permitidos
     * @param event
     */
    MessageListener.prototype.isFromAllowedDomain = function (event) {
        return (AppSettings_1.default.IFRAME_MESSAGE_VALID_ORIGIN_DOMAIN().findIndex(function (allowedDomain, index) {
            return new UrlParser_1.default(event.origin).getHost() == allowedDomain.trim();
        }) >= 0);
    };
    return MessageListener;
}());
exports.MessageListener = MessageListener;
exports.default = MessageListener;
